import React, { useMemo } from "react";
import { hasRoles, useKeycloakContext } from "@wf/keycloak-axios-provider";
import AccessDeniedTranslated from "../../AccessDeniedTranslated";

const usersWithGroupAccess = ["DECLARANT"];
const usersWithRoleAccess = { "invoice-system-client": ["INDIVIDUAL"] };

const PrepaymentAccess = _ref => {
  const { children, showAccessDenied } = _ref;
  const keycloakContext = useKeycloakContext();
  const userData = keycloakContext?.keycloak?.tokenParsed;
  const roles = keycloakContext.getUserData()?.roles;

  const hasPrepaymentAccess = useMemo(() => {
    return (
      userData?.groups?.some(group => usersWithGroupAccess.includes(group)) || hasRoles(usersWithRoleAccess, roles)
    );
  }, [userData, roles]);

  return hasPrepaymentAccess ? children : showAccessDenied ? <AccessDeniedTranslated /> : null;
};

PrepaymentAccess.defaultProps = {
  children: null
};

export { PrepaymentAccess as default };
